import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Container, Row, Col, Form, Button, Alert } from 'react-bootstrap';
import { accountService } from '../functions/loginApi';
import { authService } from '../functions/authenticate';
import { TailSpin } from 'react-loader-spinner';

import '../scss/RegisterMember.scss';
import '../scss/MobileLogin.scss';

const MobileLogin = ({ setLogin, userID, setUserID, setUserName, authToken, setAuthToken }) => {
    const [open, setOpen] = useState(true);
    const [loading, setLoading] = useState(false);
    const [signInErr, setSignInErr] = useState(false);
    const [signInMessage, setSignInMessage] = useState('');
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();

    useEffect(() => {
        let token = localStorage.getItem('authToken');
        
        console.log(token);

        if(token === null || token === undefined || token === "") {
            console.log(token);
        } else {
            setAuthToken(token);
        }
    }, []);

    useEffect(() => {
        if(authToken && authToken!==null && authToken!=='')
        {
            console.log(authToken);
            authService.validateAuthToken(authToken)
                .then(response => {
                    // console.log(response);
                    setAuthToken(response.body.token);
                    localStorage.setItem('authToken', response.body.token);
                    localStorage.setItem('device', searchParams.get('platform')===null ? '' : searchParams.get('platform'));
                    localStorage.removeItem('runnerList');

                    if(searchParams.get('mode') && searchParams.get('mode')!==null && searchParams.get('mode')==='editRegistration') {

                        // alert(searchParams.get('paymentID'));

                        accountService.getRegistrationByPaymentID(searchParams.get('paymentID'), authToken)
                            .then(response => {

                                // alert('ok');
                                console.log(response);

                                if(response.status) {
                                    let runners = response.body.runner;
                                    let newRunners = [];

                                    runners.map((data) => {
                                        // console.log(data);
                    
                                        const obj = {
                                            individualID: data.individualID,
                                            paymentID: data.paymentID,
                                            fullname: data.fullname,
                                            gender: data.gender,
                                            email: data.email,
                                            bibName: data.bib_name,
                                            dob: data.dob,
                                            nationality: data.nationality,
                                            mykad: data.mykad,
                                            contact: data.phone,
                                            emergencyName: data.emergency_name,
                                            emergencyContact: data.emergency_contact,
                                            medicalAttention: data.medical_attention,
                                            category: data.race_cat,
                                            categoryType: data.race_cat_type,
                                            tshirt_size: data.tshirt_size,
                                            finisher: data.finisher_size,
                                            racePackCollection: data.racePackCollection,
                                            deliveryAddress : data.deliveryAddress,
                                            deliveryPostcode : data.deliveryPostcode,
                                            deliveryCity : data.deliveryCity,
                                            deliveryState : data.deliveryState,
                                            deliveryCountry : data.deliveryCountry,
                                        };
                                        newRunners.push(obj);
                                    });
                    
                                    localStorage.setItem('editList', JSON.stringify(newRunners));
                    
                                    var updateToken =  authService.encryptUpdateToken(userID);
                                    // console.log(updateToken);


                                    navigate('/EditRegistration?updateToken=' + updateToken);

                                }

                                
                            })
                            .catch(err => {
                                console.log(err);
                                setSignInMessage('Ops... Something went wrong. Please try again later.');
                                setSignInErr(true);
                                setLoading(false);
                            });

                    } else if(searchParams.get('mode') && searchParams.get('mode')!==null && searchParams.get('mode')==='merchant') {
                        // alert("Go to Eshop");
                        navigate("/Shop");
                    } else {
                        navigate("/Register");
                    }

                })
                .catch(err => {
                    console.log(err);
                })
        }
    }, [authToken]);

    useEffect(() => {
        if(searchParams.get('individualID') && searchParams.get('individualID')!==null && searchParams.get('individualID')!=='')
        {
            setLoading(true);
            // alert(window.location.href);
            accountService.mobileSignIn(searchParams.get('individualID') , searchParams.get('tempID'))
                .then(response => {
                    console.log(response);
                    updateLoginStatus(response, '');
                })
                .catch(err => {
                    console.log(err);
                    setSignInMessage('Ops... Something went wrong. Please try again later.');
                    setSignInErr(true);
                    setLoading(false);
                });
        }
    }, [searchParams]);

    function updateLoginStatus(response, type) {
        if(response.status) {
            let user = response.body.user;
            setUserID(user.individualID);
            localStorage.setItem('userID', user.individualID);

            let fname = user.firstname === null ? '' : user.firstname;
            let lname = user.lastname === null ? '' : user.lastname
            let name = fname + ' ' + lname;
            setUserName(name);
            localStorage.setItem('userName', name);
            
            setLogin(true);
            setAuthToken(response.body.token);
            localStorage.setItem('authToken', response.body.token);
            
            // navigate("/Profile/myRun");
            
        }
        else
        {
            setSignInMessage(response.body.message);
            setSignInErr(true);
            setLoading(false);
        }
    }

    return (
        <Row className="mobileLogin">
            <Col>
                {/* <img src={`${process.env.PUBLIC_URL}/images/run-gif.gif`} alt=""  /> */}
                <TailSpin
                    height="80"
                    width="80"
                    color="#ccc"
                    ariaLabel="tail-spin-loading"
                    radius="1"
                    wrapperStyle={{margin: "0 auto"}}
                    wrapperClass="loader"
                    visible="true"
                />
                <h4>Loading...</h4>
            </Col>
        </Row>
    );
}

export default MobileLogin;